import createAction from '../actions';

export const GET_CURRENT_MODAL = createAction('GET_CURRENT_MODAL');

export const getCurrentModal = () => (dispatch, getState) => {
  const state = getState();
  const { queue } = state.messageSystem.modals;

  if (queue.length === 0) return;

  const modal = queue[0];
  let timerId;

  if (modal.autoDismissTime) {
    timerId = setTimeout(modal.onAutoDismissTime, modal.autoDismissTime);
  }

  dispatch({
    type: GET_CURRENT_MODAL,
    payload: {
      currentModal: modal.id,
      timerId,
    },
  });
};
